import { jsx as _jsx } from "react/jsx-runtime";
import { createRoot } from 'react-dom/client';
import { ModuleRegistry } from 'ag-grid-enterprise';
import { AllEnterpriseModule } from 'ag-grid-enterprise';
// import { LicenseManager } from 'ag-grid-enterprise'
import RouterComponent from './router';
import log from './logger';
ModuleRegistry.registerModules([AllEnterpriseModule]);
// Set the AG Grid Enterprise license key here when available
// LicenseManager.setLicenseKey('YOUR_LICENSE_KEY_HERE')
log.info('Pulse UI app starting with AG Grid Enterprise...');
const container = document.getElementById('root');
if (!container)
    throw new Error('Root container missing in index.html');
const root = createRoot(container);
root.render(_jsx(RouterComponent, {}));
